/*
 * @FilePath: /kitchen-online-web/src/redux/reducers/door.js
 * @Author: Yu Wang
 * @Date: 2021-08-04 09:32:59
 * @LastEditors: lixin jiang
 * @LastEditTime: 2021-12-01 15:42:39
 */
const doorAction = {
  'bottom-door': (state, payload) => ({ // 底柜门板信息
    ...state,
    bottomDoorList: {
      ...payload,
    },
  }),
  'top-door': (state, payload) => ({ // 顶柜门板信息
    ...state,
    topDoorList: {
      ...payload,
    },
  }),
  bottomDoorScreen: (state, payload) => ({ // 底柜筛选信息
    ...state,
    bottomDoorScreen: { ...payload },
  }),
  topDoorScreen: (state, payload) => ({ // 顶柜筛选信息
    ...state,
    topDoorScreen: { ...payload },
  }),
  'door-detail': (state, payload) => ({
    ...state,
    doorDetail: { ...payload },
  }),
  bottomCabinetList: (state, payload) => ({
    ...state,
    bottomCabinetList: [...payload],
  }),
  topCabinetList: (state, payload) => ({
    ...state,
    topCabinetList: [...payload],
  }),
  setIsShowFilter: (state, payload) => ({
    ...state,
    isShowFilter: payload,
  }),
};

export default doorAction;
